const defaultState = {
  userAgent: null,
  ip: null
};

export default (state = defaultState) => state;
